// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root___MVHW","list":"PatternAutocomplete_list__3jiqM"};